/**
 * Cookieのセットアップ
 * @param key 設定するキー名
 * @param value 設定する値
 * @param path パス属性
 */
const setupCookie = (key: string, value: string, path: string): void => {
  document.cookie = `${key}=${value}; Path=/${path}; Secure`;
};

export default setupCookie;
